// Default data in case it's not loaded from server or props/state
export default {
  defaultDateFormat: 'YYYY-MM-DD',
  defaultMXThresholds: {
    days: 30,
    cycles: 10,
    flights: 10,
    landings: 10,
    apu_seconds: 36000,
    flight_seconds: 36000,
  },
};
